module.exports = __webpack_public_path__ + "static/fonts/lato-normal.bd03a2c.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lato-font/fonts/lato-normal/lato-normal.woff2
// module id = 8J+4
// module chunks = 13